import { defineStore } from "pinia"

export const useMenuStore = defineStore('menu', () => {
    const menuOpened = ref(false)
    const menuUser = ref(false)
    const targeOpened = ref(true)
    const isCollapsed = ref(false)
    const chatOpened = ref(false)
    const gameTab = ref()
    const topAd = ref(false)

    const toggle = function () {
        menuOpened.value = !menuOpened.value
        if (menuOpened.value) {
            isCollapsed.value = false
        }
    }
    
    const chat = function () {
        console.log('chat clicou')
        chatOpened.value = !chatOpened.value
    }

    const collapseMenu = function (forcedState) {
        if (typeof forcedState === 'boolean') {
            isCollapsed.value = forcedState
        } else {
            isCollapsed.value = !isCollapsed.value
        }
    }

    const closeTopAd = function() {
        topAd.value = false;
    }

    const targe = function () {
        targeOpened.value = !targeOpened.value
    }

    const modalClose = function () {
        menuOpened.value = false
    }

    const modalOpen = function () {
        menuOpened.value = true
    }

    const userOpen = function () {
        menuUser.value = true
    }

    const userClose = function () {
        menuUser.value = false
    }

    const getFeatured = (menuName) => {
        return menuName === 'cassino'
    }

    return {
        menuOpened,
        chat,
        isCollapsed,
        collapseMenu,
        targeOpened,
        chatOpened,
        toggle,
        getFeatured,
        modalOpen,
        modalClose,
        targe,
        topAd,
        closeTopAd,
        userOpen,
        userClose,
        menuUser
    }
})